import { Spacing16, Spacing8 } from 'autogen/design-tokens/tokens';
import type { BasketLineViewModel } from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import ProductImage from 'components/generic/productImage';
import { Typography } from 'components/generic/typography';
import BasketDiscountInfo from 'components/checkout/components/BasketOverview/components/DiscountInfo/BasketDiscountInfo';
import InlineButton from 'components/generic/InlineButton';
import Default from 'modules/modal/layouts/defaultLayout';
import Card from 'components/generic/card';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import { memo } from 'react';
import Price from './components/Price';
import RemoveItemButton from './components/Actions/components/RemoveItemButton';
import { PriceContainer } from './shared/styles';
import { ProductImageContainer } from 'components/generic/productImage/shared/styles';

const StyledCard = styled(Card)`
    border-radius: 0;
`;

export const Grid = styled.div`
    display: grid;
    gap: ${Spacing16};
    grid-template-columns: 104px 1fr;
    align-items: start;

    ${breakpoint.up(sizes.lg)} {
        grid-template-columns: 104px 1fr;
    }
`;

const BasketMatasPlusItem = ({ model }: { model: BasketLineViewModel }) => {
    const { productId, image, discountInfo, matasPlusInfo } = model;

    return (
        <StyledCard size={null}>
            <Card.Content>
                <Grid>
                    <ProductImageContainer>
                        <ProductImage width={104} image={image} transformType="SquareScale" />
                    </ProductImageContainer>

                    <Flex.Column>
                        <Flex.Row justifyContent="space-between">
                            <Flex.Column gap={Spacing8}>
                                <Typography.Body as="span">{matasPlusInfo?.heading}</Typography.Body>
                                <Typography.Body as="span" size="S">
                                    {matasPlusInfo?.monthlyPrice}
                                </Typography.Body>
                                <Typography.Body as="span" size="S" strong>
                                    {matasPlusInfo?.signupText} -{' '}
                                    <InlineButton
                                        onClick={async () => {
                                            const { default: HtmlModal } = await import(
                                                /* webpackChunkName: "htmlModal" */ 'modules/modal/htmlModal'
                                            );
                                            const modal = HtmlModal({
                                                layout: { component: (props) => <Default {...props} /> }
                                            });
                                            modal({ url: matasPlusInfo?.readMoreLink.link.linkAction.url });
                                        }}
                                    >
                                        {matasPlusInfo?.readMoreLink.text}
                                    </InlineButton>
                                </Typography.Body>
                                <Typography.Body as="span" size="S">
                                    {matasPlusInfo?.signupDisclaimer}
                                </Typography.Body>
                            </Flex.Column>

                            <PriceContainer gap={Spacing8} alignItems="end">
                                {discountInfo && <BasketDiscountInfo model={discountInfo} />}
                                <Price model={model} />
                            </PriceContainer>
                        </Flex.Row>

                        <Flex.Row justifyContent="end">
                            <RemoveItemButton productId={productId} />
                        </Flex.Row>
                    </Flex.Column>
                </Grid>
            </Card.Content>
        </StyledCard>
    );
};

export default memo(BasketMatasPlusItem);
